<div class="page-container explorer-container container w-100">
  <app-utility-toolbar
    [current]="'caseExplorer'"
    [vertical]="true"
    class="vertical {{ navCollapsed ? 'w-5' : 'w-15' }}"
    (toggleCollapse)="toggleNavCollapse()"
    [links]="dashboardLinks"
  ></app-utility-toolbar>
  <div
    class="explorer-content-container ps-3"
    [ngClass]="{ collapsed: navCollapsed }"
  >
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    >
      <button
        mat-button
        color="primary"
        class="grid-button header-button"
        [disabled]="fileLoading"
        [matMenuTriggerFor]="menu"
        matTooltip="Limit {{ downloadLimit }}"
        matTooltipPosition="above"
        aria-label="Download excel file of grid button with a menu"
        ><span class="button-label-with-icon">
          @if (fileLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <mat-icon>cloud_download</mat-icon>
          }
          Download Excel File</span
        >
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="dlXlsx()">
          <mat-icon>file_download</mat-icon>
          <span>All Data</span>
        </button>
        <button mat-menu-item (click)="dlXlsx(true)">
          <mat-icon>filter_alt</mat-icon>
          <span>Filtered Data</span>
        </button>
      </mat-menu>
    </app-rb-grid>
  </div>
</div>
